import React from 'react';
import ProductCard from './components/ProductCard';

function App(props) {
  return (
    <div id="xylene-widget">
      <ProductCard code={props.product}/> {/* product is the data passed in from the widget data-product=... */}
    </div>
  );
}

export default App;
